import React, { useState } from "react";
import { Container, Grid, Button, AppBar, IconButton, Toolbar, Collapse, MenuList, MenuItem, Stack, List, ListItem, Card, Divider, Box, FormGroup, ListItemText, useScrollTrigger } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import Logo from "../Shared/Logo";
import ConsentScripts from "../../utils/ConsentScripts";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import PricingBoxes from "../Shared/PricingBoxes";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import Austria from 'images/austria.png';
import Europe from 'images/eu.png';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Landingpage = () => {
  const [menuShown, showMenu] = useState(false);

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window,
  });

  const MenuItems = (props) => {
    return (
      <MenuList
        sx={{
          display: props.responsive ? { xs: "none", md: "flex" } : "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "center" },
          gap: { sx: 1, md: 2 },
          flexGrow: 1,
        }}
      >
        {/* <Button fullWidth={!props.responsive}>
          Features
        </Button>
        <Button fullWidth={!props.responsive}>
          Use Cases
        </Button>
        <Button fullWidth={!props.responsive}>
          Pricing
        </Button>
        <Button fullWidth={!props.responsive}>
          FAQ
        </Button> */}

        <Stack
          direction="row"
          sx={{ marginLeft: "auto", display: { xs: "none", md: "flex" } }}
          spacing={1}
        >
          <Button
            variant="text"
            color="primary"
            size="small"
            component={NavLink}
            to="/login"
          >
            <span className={trigger ? "text-primary" : "text-white"}>Sign in</span>
          </Button>
          <Button
            component={NavLink}
            variant="outlined"
            color="secondary"
            size="small"
            to="/signup"
          >
            <span className={trigger ? "text-primary" : "text-white"}>Create workspace</span>
          </Button>
        </Stack>

        <Button
          component={NavLink}
          to="/login"
          sx={{ display: { md: "none" } }}
          fullWidth
        >
          Sign in
        </Button>

        <Button
          component={NavLink}
          to="/signup"
          sx={{ display: { md: "none" } }}
          fullWidth
        >
          Create workspace
        </Button>
      </MenuList>
    );
  };

  return <>
    <ConsentScripts />

    <AppBar component="nav" position="fixed" sx={{ background: trigger ? "rgba(250, 251, 251, 0.8) !important" : "transparent", boxShadow: trigger ? "var(--box-shadow-flat) !important" : "none" }}>
      <Toolbar sx={{ gap: "3rem" }}>
        <Logo color={trigger ? "primary" : "white"} />
        <IconButton
          sx={{ marginLeft: "auto", display: { md: "none" } }}
          onClick={() => showMenu((shown) => !shown)}
          color={trigger ? "primary" : "secondary"}
        >
          <MenuIcon />
        </IconButton>
        <MenuItems responsive />
      </Toolbar>
    </AppBar>

    <Collapse
      in={menuShown}
      className="bg-white"
      sx={{ position: "fixed", width: "100%", top: "56px", zIndex: 1, boxShadow: "var(--box-shadow-flat)", display: { md: "none" } }}
    >
      <MenuItems />
    </Collapse>

    <header className="bg-mesh" style={{ minHeight: "80vh", paddingTop: "8rem" }}>
      <Container maxWidth="lg" className="text-center">
        <h1 className="text-white animate__animated animate__fadeInUp"><strong>AI-driven lessons learned copilot</strong></h1>
        <h2 className="text-secondary text-light animate__animated animate__fadeIn">
          Lessonice collects lessons learned and helps finding solutions that boost everyones performances.
        </h2>

        <Stack direction="row" spacing={2} sx={{mt: 4, justifyContent: "center"}}>
          <Button
            variant="text"
            color="secondary"
            size="large"
            component={Link}
            to="https://calendly.com/office-lessonice/demo"
            target="_blank"
          >
            Book a demo
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            component={NavLink}
            to="/signup"
            endIcon={<ArrowRightAltIcon />}
            sx={{display: {xs: "none", sm: "inline-flex"}}}
          >
            Try out now
          </Button>
        </Stack>

      </Container>
    </header>

    <section className="bg-white" style={{ padding: "7rem 0 5rem" }}>
      <Container maxWidth="lg" className="text-center">
        <h3 className="text-info text-uppercase text-light">Transforming lessons learned into success</h3>
        <h1 style={{marginTop: '1rem'}}>&#x201C;Imagine the most experienced coworker by your side <span className="text-secondary">- anywhere, anytime.&#x201D;</span></h1>
      </Container>
    </section>

    <Divider />

    <section className="bg-white" style={{ padding: "7rem 0" }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid size={{xs: 12, md: 6}}>
            <h3 className="text-info text-uppercase text-light">Share best practices seamlessly</h3>
            <h1 style={{margin: "1rem 0"}}>Break knowledge silos, boost collaboration.</h1>
            <List>
              <ListItem sx={{p: "0.5rem 0", gap: 1}} alignItems="flex-start">
                <TaskAltIcon color="secondary" sx={{mt: 0.5}} /> <h3 className="text-light text-secondary">Ensure that no valuable lesson is lost.</h3>
              </ListItem>
              <ListItem sx={{p: "0.5rem 0", gap: 1}} alignItems="flex-start">
                <TaskAltIcon color="secondary" sx={{mt: 0.5}} /> <h3 className="text-light text-secondary">Search, retrieve, and apply relevant lessons learned in real-time to solve challenges faster and smarter.</h3>
              </ListItem>
              <ListItem sx={{p: "0.5rem 0", gap: 1}} alignItems="flex-start">
                <TaskAltIcon color="secondary" sx={{mt: 0.5}} /> <h3 className="text-light text-secondary">Turn lessons into real-time guidance that improves productivity, reduces risks, and drives continuous improvement.</h3>
              </ListItem>
            </List>
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
          </Grid>
        </Grid>      
      </Container>
    </section>

    <section className="bg-secondary" style={{ padding: "7rem 0" }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid size={{xs: 12, md: 6}}>
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
            <h3 className="text-info text-uppercase text-light">Return on Investment</h3>
            <h1 style={{margin: "1rem 0"}}>Make lessons learned a valuable asset</h1>
            <h3 className="text-light text-secondary">The amount of expensive employees in non valuable lessons learned meetings is far too high.</h3>
            <Grid container sx={{mt: 1}} spacing={3}>
              <Grid size={6}>
                <h2>More than 75%</h2>
                <p className="text-secondary">of global companies conduct lessons learned sessions on a regulary basis.</p>
              </Grid>
              <Grid size={6}>
                <h2>1 out of 2</h2>
                <p className="text-secondary">employees state that the lessons learned process in their organization is barely sufficient.</p>
              </Grid>
            </Grid>
          </Grid>
        </Grid>      
      </Container>
    </section>

    <section style={{padding: "7rem 0"}} className="bg-mesh">
      <Container maxWidth="lg">
        <Grid container sx={{alignItems: "center"}}>
          <Grid size={{xs: 12, md: 8}}>
            <h3 className="text-secondary text-uppercase text-light">Get your lessons learned to the next level</h3>
            <h1 className="text-white">Book your personal demo</h1>
          </Grid>
          <Grid size={{xs: 12, md: 4}}>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              component={Link}
              to="https://calendly.com/office-lessonice/demo"
              target="_blank"
              startIcon={<EventAvailableIcon />}
            >
              Book a demo
            </Button>
          </Grid>
        </Grid>
      </Container>
    </section>

    <section id="pricing" className="bg-secondary" style={{ padding: "7rem 0" }}>
      <Container maxWidth="lg">
        <FormGroup className="text-center" sx={{mb: 3}}>
          <h3 className="text-info text-uppercase text-light">Our prices scale with your business</h3>
          <h1 className="text-center text-primary">Flexible Pricing</h1>
        </FormGroup>
        <PricingBoxes />
      </Container>
    </section>

    <footer className="bg-black" style={{ padding: "3rem 0" }}>
      <Container maxWidth="lg" sx={{ py: 5 }}>
        <p className="text-secondary text-uppercase text-light">Frequently asked questions</p>
        <h2 className="text-white text-lg">Your concerns are important to us</h2>

        <Grid container spacing={5} sx={{mt: 1}}>
          <Grid size={{xs: 12, md: 6}}>
            <List>
              <FaqItem question="Will Lessonice use our data to train AI models?" answer="We won't use any of your data to train our AI models withouth your explicit consent. You can send us feedback anytime in order to optimize our algorithms. Any kind of info you voluntarily want to provide us together with your feedback is appreciated but not necessarily needed to be used to fine-tune our models." />
              <FaqItem question="Where is my company data hosted?" answer="Lessonice services are securely hosted on servers in the European Union that align with the highest safety and encryption standards." />
              <FaqItem question="What data does Lessonice access?" answer="We comply with the General Data Protection Regulation (GDPR) and the AI Act. Any kind of data in our system is consented and released by the users. In accordance with the GDPR, this data can be requested to be reviewed or removed at any time. This applies to all our services on offer." />
              <FaqItem question="How do you ensure that no company secrets are revealed?" answer="We give our best efforts to assure your data not being leaked or breached by any means. Nevertheless, any system can only be as conscientious and secure as its users. We endeavor to implement appropriate security precautions in line with the latest state of the art security measures to avoid any inconveniences." />
            </List>
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
            <List>
              <FaqItem question="What's the difference between Lessonice and ChatGPT?" answer="ChatGPT is an AI chatbot designed to engage in interactive conversations covering a wide range of different topics. However, ChatGPT does not have access to your company data. Lessonice in turn is a business software focused on sharing and discovering lessons learned, insights, and knowledge. It provides a structured way to document and retrieve company related data." />
              <FaqItem question="What's the difference between Lessonice and Microsoft Copilot?" answer="Microsoft Copilot is an AI assistant deeply integrated into the Microsoft ecosystem to enhance productivity. Lessonice as such enables enterprises to combine their knowledge in a more encapsulated way, so that not everything and every data is around that should not be there. As an enterprise-ready solution, Lessonice offers more opportunities to share knowledge on point." />
            </List>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="lg" sx={{ py: 5 }}>

        <Card className="bg-dark">
          <Grid container spacing={1}>
            <Grid size={{xs: 12, md: 8}}>
              <Logo color="white" />
              <List sx={{mt: 3}}>
                <ListItem sx={{px: 0, py: 1}}>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <img src={Austria} width={42} height={42} />
                    <Box>
                      <p className="text-white">Made in Austria</p>
                      <p className="text-secondary">Proven by world leading industries</p>
                    </Box>
                  </Stack>
                </ListItem>
                <ListItem sx={{px: 0, py: 1}}>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <img src={Europe} width={42} height={42} />
                    <Box>
                      <p className="text-white">GDPR &amp; AI Act compliant</p>
                      <p className="text-secondary">Securely hosted in the EU</p>
                    </Box>
                  </Stack>
                </ListItem>
              </List>
            </Grid>
            <Grid size={{xs: 12, md: 4}}>
              <p className="text-uppercase text-light text-secondary">Information</p>
              <List>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/terms" className="text-white">Terms of Service</NavLink></ListItem>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/privacy" className="text-white">Privacy Policy</NavLink></ListItem>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/beta" className="text-white">Beta Test Agreement</NavLink></ListItem>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/legal" className="text-white">Legal Notice</NavLink></ListItem>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/legal" className="text-white">Contact</NavLink></ListItem>
              </List>
            </Grid>
          </Grid>

          <Divider sx={{borderColor: 'var(--text-secondary) !important', my: 3, opacity: 0.5}} />

          <p className="text-secondary">
            &copy; Innomaze FlexCo
          </p>
        </Card>
      </Container>
    </footer>
  </>;
};

const FaqItem = (props: { question: string, answer: string }) => {

  const [isOpen, shouldOpen] = useState(false);

  return <ListItem disablePadding>
    <Box>
      <Stack sx={{cursor: "pointer"}} direction="row" onClick={() => shouldOpen(!isOpen)} alignItems="center" justifyContent="space-between">
        <h3 className="text-white text-light">{props.question}</h3>
        { isOpen ? <ExpandMoreIcon color="secondary" /> : <KeyboardArrowRightIcon color="secondary" /> }
      </Stack>
      <Collapse in={isOpen}>
        <p className="text-secondary">{props.answer}</p>
      </Collapse>
      <Divider sx={{borderColor: 'var(--text-secondary) !important', my: 2, opacity: 0.5}} />
    </Box>
  </ListItem>
}

export default Landingpage;
